export default {
  state: {
    loading: false,
    error: null,
    globalError: null,
    globalNotification: null
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      console.log('setting error : ' + payload)
      if (payload.code === 0) {
        state.globalError = payload
      } else {
        state.error = payload
      }
    },
    clearError (state) {
      state.error = null
      state.globalError = null
    },
    setNotification (state, payload) {
      state.globalNotification = payload
    },
    clearNotification (state) {
      state.globalNotification = null
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    clearNotification ({ commit }) {
      commit('clearNotification')
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    globalError (state) {
      return state.globalError
    },
    globalNotification (state) {
      return state.globalNotification
    }
  }
}
